import { render } from "./p-checkbox.vue?vue&type=template&id=4c6e2a90&scoped=true"
import script from "./p-checkbox.vue?vue&type=script&lang=js"
export * from "./p-checkbox.vue?vue&type=script&lang=js"

import "./p-checkbox.vue?vue&type=style&index=0&id=4c6e2a90&scoped=true&lang=scss"
import "./p-checkbox.vue?vue&type=style&index=1&id=4c6e2a90&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6e2a90"],['__file',"src/components/p-checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c6e2a90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c6e2a90', __exports__)) {
    api.reload('4c6e2a90', __exports__)
  }
  
  module.hot.accept("./p-checkbox.vue?vue&type=template&id=4c6e2a90&scoped=true", () => {
    api.rerender('4c6e2a90', render)
  })

}


export default __exports__